module.exports = __webpack_public_path__ + "img/icon-facebook -color.e303d48a.svg";